import { useEffect, useState } from 'react'
import ViewportModule from './Module'
import { IUseViewport, UseViewportMode } from './types'

const useViewport: IUseViewport = (mode = UseViewportMode.CURRENT) => {
  const [viewport, setViewport] = useState({
    current: UseViewportMode.REAL === mode ? ViewportModule.realViewport : ViewportModule.viewport
  })

  useEffect(
    () =>
      ViewportModule.onUpdate(
        () =>
          void setViewport({
            current: UseViewportMode.REAL === mode ? ViewportModule.realViewport : ViewportModule.viewport
          })
      ),
    [mode]
  )

  return viewport.current
}

export default useViewport
